import * as api from '@/api/facility'
import Facility from '@/store/models/facility'
import formData from '@billow/js-helpers/src/utilities/form-data'

export let state = {
  facility: new Facility,
  facilities: {
    data: []
  },
  facilityList: []
}

export let mutations = {
  setFacilities: (state, payload) => state.facilities = payload,

  setFacilityList: (state, payload) => state.facilityList = payload,

  setFacility: (state, payload) => state.facility = (new Facility).hydrate(payload),
  reset: state => state.facility = new Facility,

  setGalleryId: (state, payload) => state.facility.gallery_id = payload,
  setName: (state, payload) => state.facility.name = payload,
  setFile: (state, payload) => state.facility.file = payload,
  setSort: (state, payload) => state.facility.sort = payload,
  setSeatingCapacity: (state, payload) => state.facility.seating_capacity = payload,
  setMinimumHours: (state, payload) => state.facility.minimum_hours = payload,
  setIntro: (state, payload) => state.facility.intro = payload,
  setDescription: (state, payload) => state.facility.description = payload,
  setWeekStartTime: (state, payload) => state.facility.week_start_time = payload,
  setWeekSlots: (state, payload) => state.facility.week_slots = payload,
  setWeekendStartTime: (state, payload) => state.facility.weekend_start_time = payload,
  setWeekendSlots: (state, payload) => state.facility.weekend_slots = payload,
  setActive: (state, payload) => state.facility.active = payload,
  setFeatured: (state, payload) => state.facility.featured = payload,
  setServesAlcohol: (state, payload) => state.facility.serves_alcohol = payload,
  setWeekdaysAvailable: (state, payload) => state.facility.weekdays_available = payload,
  setWeekendsAvailable: (state, payload) => state.facility.weekends_available = payload,
  setRoles: (state, payload) => state.facility.roles = payload,
  setBaseRate: (state, payload) => state.facility.base_rate = payload,
  setBaseDeposit: (state, payload) => state.facility.base_deposit = payload,
  setBaseCleaning: (state, payload) => state.facility.base_cleaning = payload,
  setBaseCleaningAfterHours: (state, payload) => state.facility.base_cleaning_after_hours = payload,
  setBaseSecurity: (state, payload) => state.facility.base_security = payload,
  setBaseSecurityAfterHours: (state, payload) => state.facility.base_security_after_hours = payload,

  // Pricing
  setRate: (state, { index, rate }) => state.facility.pricing[index].rate = rate,
  setDeposit: (state, { index, deposit }) => state.facility.pricing[index].deposit = deposit,
  setCleaning: (state, { index, cleaning }) => state.facility.pricing[index].cleaning = cleaning,
  setCleaningAfterHours: (state, { index, cleaning_after_hours }) => state.facility.pricing[index].cleaning_after_hours = cleaning_after_hours,
  setSecurity: (state, { index, security }) => state.facility.pricing[index].security = security,
  setSecurityAfterHours: (state, { index, security_after_hours }) => state.facility.pricing[index].security_after_hours = security_after_hours,
}

export let actions = {

  list: ({ commit }) => new Promise((resolve, reject) => {
    api.list(response => {
      commit('setFacilityList', response.data)
      resolve()
    }, reject)
  }),

  paginate: ({ commit }, path) => new Promise((resolve, reject) => {
    api.paginate(path, response => {
      commit('setFacilities', response.data)
      resolve()
    }, reject)
  }),

  create: ({ state, commit }) => new Promise((resolve, reject) => {
    api.create(formData(state.facility.payload), () => {
      commit('reset')
      resolve()
    }, reject)
  }),

  load: ({ commit }, facility) => new Promise((resolve, reject) => {
    api.load(facility, response => {
      commit('setFacility', response.data)
      resolve()
    }, reject)
  }),

  save: ({ state, commit }) => new Promise((resolve, reject) => {
    api.save(state.facility, () => {
      commit('reset')
      resolve()
    }, reject)
  }),

  removePricing: ({ }, pricing) => new Promise((resolve, reject) => {
    api.removePricing(pricing.id, resolve, reject)
  }),

  removeExtra: ({ }, extra) => new Promise((resolve, reject) => {
    api.removeExtra(extra.id, resolve, reject)
  })

}